export const CONST_LIST_OPERATOR = {
  HOLDER_NAME_OR_ID: '氏名もしくは運営員コードを入力',
  NO_DATA: 'データがありません',
};
